import { Image } from '@acme/assets';
import React from 'react';

interface BlockedProps {
  className?: string;
}

export const Blocked: React.FC<BlockedProps> = ({ className = '' }) => (
  <div
    className={`font-inter flex w-full flex-col gap-2 pb-10 text-center leading-[normal] ${className}`}
  >
    <div className="flex items-center justify-center">
      <Image
        name="forgot-password-bro-3"
        width="100%"
        className="flex-grow text-center"
      />
    </div>
    <div className="pt-12 font-medium">Вход временно заблокирован</div>
    <div className="text-text-secondary">
      <span className="text-center">
        <p>Повторите попытку через 15 минут</p>
        <p>или обратитесь в поддержку</p>
      </span>
    </div>
  </div>
);
